'use client';

import { getMaturityHistory } from '@/domain/products/api';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Skeleton } from '@andritzot/metris-web-ui/feedback/skeleton';
import { useQuery } from '@tanstack/react-query';
import { Accordion, AccordionTab } from 'primereact/accordion';

import MaturityHistoryDataTable from './MaturityHistoryDataTable';

interface MaturityHistoryProps {
  idProduct: number;
}

const MaturityHistory = ({ idProduct }: MaturityHistoryProps) => {
  const { data: history, isLoading } = useQuery({
    queryKey: ['maturity-history', idProduct],
    queryFn: () => getMaturityHistory(idProduct),
  });

  if (isLoading) {
    return (
      <div>
        <Skeleton width="100%" height="2rem" />
      </div>
    );
  }

  if (!history) {
    return null;
  }

  return (
    <Box sx={{ '& a': { textDecoration: 'none' } }}>
      <Accordion style={{ marginBottom: '1rem' }}>
        <AccordionTab header="History" style={{ padding: 0 }}>
          <MaturityHistoryDataTable history={history} />
        </AccordionTab>
      </Accordion>
    </Box>
  );
};

export default MaturityHistory;
